import { useState } from 'react';
import moment from 'moment';
import { Text } from 'components/ui/base/typography';
import config from 'config/config';
import { IrelandNotification, IrelandNotificationType } from 'store/declarations/ireland/ireland-notification';
import { ErrorRow } from '../../declaration-errors/ais/RevenueImportErrorDetails';
import {
    BackToList,
    StickyDrawerHeader,
    CodeDiv,
    MessageDiv,
    ShowDetailsDiv,
    ShowRawDataDiv,
    StyledErrorRow,
    Title,
} from '../../DeclarationsNotificationsDrawer.styles';
import RawMessage from '../../RawMessage';
import { colors } from '../../../../../../theme';

const DATE_FORMAT = 'DD/MM/YYYY HH:mm:ss';

const IrelandNonActionRequiredNotification = ({
    latestNotification,
    messageName,
}: {
    latestNotification: IrelandNotification;
    messageName: string;
}) => {
    const [showRawMessage, setShowRawMessage] = useState<boolean>(false);
    const [showDetails, setShowDetails] = useState<boolean>(false);

    const {
        type,
        message,
        remarks,
        notificationDate,
        rawMessage,
        timeLimitForControl,
        underControlGoodsShipmentItems,
    } = latestNotification;

    const controlAgencies = Array.from(
        new Set(
            underControlGoodsShipmentItems?.flatMap(
                (item) => item.controlTypes?.map((controlType) => controlType.controlAgency) ?? []
            ) ?? []
        )
    ).join(', ');

    const summaryView = (
        <StyledErrorRow justify="space-between">
            <CodeDiv color={colors.action}>
                <Text>{messageName}</Text>
            </CodeDiv>
            <MessageDiv>
                <Text>{message}</Text>
            </MessageDiv>
            <ShowDetailsDiv>
                <span onClick={() => setShowDetails(true)}>Show details</span>
            </ShowDetailsDiv>
        </StyledErrorRow>
    );

    const detailsView = (
        <>
            <StickyDrawerHeader>
                <BackToList onClick={() => (showRawMessage ? setShowRawMessage(false) : setShowDetails(false))}>
                    Back to list
                </BackToList>
            </StickyDrawerHeader>

            {showRawMessage ? (
                <RawMessage>{rawMessage}</RawMessage>
            ) : (
                <>
                    <Title>Message details</Title>
                    <ErrorRow label="Message:" value={message} />
                    <ErrorRow label="Remarks:" value={remarks} />
                    <ErrorRow
                        label="Notification Date:"
                        value={notificationDate ? moment(notificationDate).format(DATE_FORMAT) : undefined}
                    />
                    {type === IrelandNotificationType.UNDER_CONTROL && (
                        <>
                            <ErrorRow label="Control Agency:" value={controlAgencies} />
                            <ErrorRow
                                label="Time Limit For Control:"
                                value={moment(timeLimitForControl).format(DATE_FORMAT)}
                            />
                        </>
                    )}
                </>
            )}
        </>
    );

    if (!showRawMessage && !showDetails)
        return (
            <>
                {config.isPIT && (
                    <ShowRawDataDiv>
                        <span onClick={() => setShowRawMessage(true)}>Show raw data</span>
                    </ShowRawDataDiv>
                )}

                {summaryView}
            </>
        );
    else return <>{detailsView}</>;
};

export default IrelandNonActionRequiredNotification;
